export const PASSWORD_POLICY = {
  requiredLength: 6,
  requireDigit: false,
  requireLowercase: true,
  requireUppercase: true,
  requireNonAlphanumeric: false,
  requiredUniqueChars: 1,
} as const;

export type PasswordValidationError =
  | 'too_short'
  | 'missing_lowercase'
  | 'missing_uppercase'
  | 'insufficient_unique_chars';

export const PASSWORD_ERROR_I18N_KEYS: Record<PasswordValidationError, string> = {
  too_short: 'PASSWORD_MIN_LENGTH',
  missing_lowercase: 'PASSWORD_REQUIRE_LOWERCASE',
  missing_uppercase: 'PASSWORD_REQUIRE_UPPERCASE',
  insufficient_unique_chars: 'PASSWORD_REQUIRE_UNIQUE_CHARS',
};

export function getPasswordValidationErrorMessages(password: string): string[] {
  if (!password) {
    return [];
  }

  return validatePassword(password).errors.map((error) => PASSWORD_ERROR_I18N_KEYS[error]);
}

export function validatePassword(password: string): { valid: boolean; errors: PasswordValidationError[] } {
  const errors: PasswordValidationError[] = [];

  if (password.length < PASSWORD_POLICY.requiredLength) {
    errors.push('too_short');
  }

  if (PASSWORD_POLICY.requireLowercase && !/[a-z]/.test(password)) {
    errors.push('missing_lowercase');
  }

  if (PASSWORD_POLICY.requireUppercase && !/[A-Z]/.test(password)) {
    errors.push('missing_uppercase');
  }

  if (new Set(password).size < PASSWORD_POLICY.requiredUniqueChars) {
    errors.push('insufficient_unique_chars');
  }

  return { valid: errors.length === 0, errors };
}

export function isPasswordValid(password: string): boolean {
  return validatePassword(password).valid;
}
